"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _shared = require("./shared");

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledEntryButtonPlaceholder = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  flex: 1 0 auto;\n  width: ", ";\n  max-width: ", ";\n  min-width: ", ";\n  display: flex;\n"])), function (p) {
  return p.widthPlaceholder;
}, function (p) {
  return p.widthPlaceholder;
}, function (p) {
  return p.widthPlaceholder;
});

var Wrapper = function Wrapper(_ref) {
  var _pickem$activeBet, _pickem$activeBet2, _pickem$activeBet3, _pickem$activeBet4, _pickem$activeBet5, _pickem$activeBet6;

  var pickem = _ref.pickem,
      isActive = _ref.isActive;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_shared.FootballMatch, {
      showLogos: true,
      pickem: pickem,
      isActive: isActive
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_shared.TextStack, {
      label: "Winnings",
      value: (pickem === null || pickem === void 0 ? void 0 : (_pickem$activeBet = pickem.activeBet) === null || _pickem$activeBet === void 0 ? void 0 : _pickem$activeBet.prize) || "-",
      isMoney: pickem === null || pickem === void 0 ? void 0 : (_pickem$activeBet2 = pickem.activeBet) === null || _pickem$activeBet2 === void 0 ? void 0 : _pickem$activeBet2.prize,
      isCentered: true
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_shared.TextStack, {
      label: "Rank",
      isCentered: true,
      value: pickem !== null && pickem !== void 0 && (_pickem$activeBet3 = pickem.activeBet) !== null && _pickem$activeBet3 !== void 0 && _pickem$activeBet3.rank ? "".concat(pickem === null || pickem === void 0 ? void 0 : (_pickem$activeBet4 = pickem.activeBet) === null || _pickem$activeBet4 === void 0 ? void 0 : _pickem$activeBet4.rank, "/").concat(pickem === null || pickem === void 0 ? void 0 : pickem.betsCount) : "-"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_shared.TextStack, {
      label: "Points",
      value: (pickem === null || pickem === void 0 ? void 0 : (_pickem$activeBet5 = pickem.activeBet) === null || _pickem$activeBet5 === void 0 ? void 0 : _pickem$activeBet5.points) > -1 ? pickem === null || pickem === void 0 ? void 0 : (_pickem$activeBet6 = pickem.activeBet) === null || _pickem$activeBet6 === void 0 ? void 0 : _pickem$activeBet6.points : "-",
      isCentered: true
    })]
  });
};

var _default = Wrapper;
exports.default = _default;